const formatTravelReason = (travelReason, content) => {
    if (travelReason === "Others" && !content) {
        return "for personal reasons";
    }
    return travelReason;
};


const renterPrompt = {
    rentRequestMessage: ({ tripStart, tripEnd, content, travelReason, hostName, language }) => {
        const finalReason = formatTravelReason(travelReason, content);
        return `
      You are a professional booking assistant. Generate a polite booking message for a rent cars host.
      Write the entire message in ${language}. Translate any English input details into ${language}.
      Details:
      - tripStart: ${tripStart}
      - tripEnd: ${tripEnd}
      - Content: ${content}
      - Host name: ${hostName}
      - Travel Reason: ${finalReason}
      Rules:
      1. 1–5 sentences, friendly and professional. Do not add extra info. Use first-person ("I"/"we") and avoid third person pronouns.
      2. Greet the host by name using a natural greeting in ${language} (not "Hi" unless the language is English).
      3. Output strictly JSON: { "message": "..." } with no extra text.
      4. Do not include any English text unless the preferred language is English.`
    },

    contactHostMessage: ({ tripStart, tripEnd, content, hostName, reasonForTravel, language }) => {
        const finalReason = formatTravelReason(reasonForTravel, content);
        return `
       You are a professional booking assistant.
       Generate a short, polite booking message to a rent a car host in valid JSON format: { "message": "..." }
       Write the entire message in ${language}. Translate any English input details into ${language}.
       Details to include (rephrased naturally in ${language}):
        - tripStart: ${tripStart}
        - tripEnd: ${tripEnd}
        - Extra content: ${content}
        - Host name: ${hostName}
        - Travel Reason: ${finalReason}
        Rules:
        1. Each message: 1–5 sentences (max 1,000 characters), friendly, professional, and easy to understand.
        2. Use first-person ("I/my" or "we/our" as appropriate).
        3. Greet the host by name using a natural greeting in ${language} (not "Hi" unless the language is English). Clearly mention tripStart / tripEnd dates and travel reason.
        4. Do not include any English text unless the preferred language is English.`
    }
};

export default renterPrompt;
